import { render, staticRenderFns } from "./Icons-svg.vue?vue&type=template&id=741c83c0&"
import script from "./Icons-svg.vue?vue&type=script&lang=js&"
export * from "./Icons-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports